
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { FlexCol } from '@unreserved-frontend-v2/ui/flex/flex-col';
import { ImageWithShimmer } from '@unreserved-frontend-v2/ui/image-with-shimmer/image-with-shimmer';
import { getStaticImgSrcSets } from '@unreserved-frontend-v2/utils/get-static-img-src-sets/get-static-img-src-sets';
import { SimplifiedBaseSectionProps } from './layouts';
export interface HeroComponentProps extends SimplifiedBaseSectionProps {
    image: string;
    imageDarkOverlay?: boolean;
    children: ReactNode;
}
export const HeroComponent = ({ title = '', content = '', containerClassName = '', image, imageDarkOverlay = false, children, }: HeroComponentProps) => {
    const imageObject = getStaticImgSrcSets(image, true);
    return (<FlexCol className={twMerge(`relative items-center justify-center rounded [&>:not(:first-child)]:z-[1]`, containerClassName)}>
      <ImageWithShimmer src={image} srcset={imageObject.imageSrcSet} className="absolute" imgClassName="rounded-md"/>
      {imageDarkOverlay ? <div className="absolute inset-0 rounded-md bg-shades-1000 opacity-50"></div> : null}
      <h2 className="text-[28px] font-bold text-white">{title}</h2>
      {content ? (<p className="px-6 pt-[18px] text-lg leading-[34px] text-white md:px-[106px] md:pt-6">{content}</p>) : null}
      {children}
    </FlexCol>);
};
export default HeroComponent;

    async function __Next_Translate__getStaticProps__1955d79d533__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//learn-more/hero-component',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1955d79d533__ as getStaticProps }
  